import React from "react";
import { Link } from "react-router-dom";
import { COMPANY_INFO, SERVICES_LIST } from "../data/company";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#f3f4f6] text-gray-700 border-t border-gray-200">
      {/* Main Footer Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          
          {/* Col 1: About / Company info */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img 
                src={COMPANY_INFO.logoUrl} 
                alt={COMPANY_INFO.name} 
                className="h-8 w-auto object-contain" 
              />
            </Link>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              Kokholm Byg er et erfarent og stabilt byggefirma i Holstebro med mere end 30 års erfaring inden for murerfaget, flisearbejde og renovering.
            </p>
            <div className="pt-2">
              <span className="inline-block bg-white text-gray-800 text-xs px-3 py-1.5 rounded border border-gray-300 font-mono font-medium shadow-xs">
                CVR: {COMPANY_INFO.cvr}
              </span>
            </div>
          </div>

          {/* Col 2: Navigation */}
          <div>
            <h4 className="text-[#1e2329] text-base font-bold mb-4 tracking-wide uppercase text-xs">
              Hovedmenu
            </h4>
            <ul className="space-y-2.5 text-sm font-medium">
              <li>
                <Link to="/" className="text-gray-600 hover:text-[#c06228] transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om-kokholm-byg" className="text-gray-600 hover:text-[#c06228] transition-colors">
                  Om Kokholm Byg
                </Link>
              </li>
              <li>
                <Link to="/ydelser" className="text-gray-600 hover:text-[#c06228] transition-colors">
                  Ydelser
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="text-gray-600 hover:text-[#c06228] transition-colors">
                  Galleri
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-gray-600 hover:text-[#c06228] transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Services */}
          <div>
            <h4 className="text-[#1e2329] text-base font-bold mb-4 tracking-wide uppercase text-xs">
              Vores ydelser
            </h4>
            <ul className="space-y-2.5 text-sm font-medium">
              {SERVICES_LIST.map((service) => (
                <li key={service.slug}>
                  <Link
                    to={`/vi-tilbyder/${service.slug.replace('vi-tilbyder-', '')}`}
                    className="text-gray-600 hover:text-[#c06228] transition-colors flex items-center gap-2"
                  >
                    <i className="fa-solid fa-angle-right text-[10px] text-[#c06228]" aria-hidden="true" />
                    <span>{service.title}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Contact details */}
          <div>
            <h4 className="text-[#1e2329] text-base font-bold mb-4 tracking-wide uppercase text-xs">
              Kontaktoplysninger
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-[#c06228] mt-1" aria-hidden="true" />
                <div>
                  <p className="font-bold text-[#1e2329]">{COMPANY_INFO.name}</p>
                  <p className="text-gray-600">{COMPANY_INFO.address}</p>
                  <p className="text-gray-600">{COMPANY_INFO.city}</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-[#c06228]" aria-hidden="true" />
                <a
                  href={`tel:${COMPANY_INFO.phoneRaw}`}
                  className="nowrap-contact hover:text-[#c06228] transition-colors text-gray-800 font-medium"
                >
                  <span className="whitespace-nowrap">{COMPANY_INFO.phone}</span>
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-[#c06228]" aria-hidden="true" />
                <a
                  href={`mailto:${COMPANY_INFO.email}`}
                  className="nowrap-contact hover:text-[#c06228] transition-colors text-gray-800 font-medium"
                >
                  <span className="whitespace-nowrap">{COMPANY_INFO.email}</span>
                </a>
              </li>
              <li className="pt-2">
                <a
                  href={COMPANY_INFO.facebookUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-xs bg-white hover:bg-gray-100 text-gray-800 font-medium px-3 py-2 rounded transition-colors border border-gray-300 shadow-xs"
                >
                  <i className="fa-brands fa-facebook-f text-blue-600" aria-hidden="true" />
                  <span>Følg os på Facebook</span>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#e5e7eb] py-6 border-t border-gray-300 text-xs text-gray-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left font-medium">
          <p>© {currentYear} {COMPANY_INFO.name}. Alle rettigheder forbeholdes.</p>
          <p className="text-gray-500">Holstebro, Danmark | CVR: {COMPANY_INFO.cvr}</p>
        </div>
      </div>
    </footer>
  );
}
